import { Timestamp } from 'firebase/firestore';

export const CONTACT_INQUIRY_CATEGORIES = [
  'general',
  'account',
  'verification',
  'report',
  'trouble',
  'bug',
  'feature',
  'press',
  'other',
] as const;

export type ContactInquiryCategory = (typeof CONTACT_INQUIRY_CATEGORIES)[number];

export const CONTACT_INQUIRY_CATEGORY_LABELS: Record<ContactInquiryCategory, string> = {
  general: '一般的なお問い合わせ',
  account: 'アカウントについて',
  verification: '認証バッジについて',
  report: '不審なユーザーの報告',
  trouble: 'トラブル・被害の相談',
  bug: '不具合・エラーの報告',
  feature: '機能改善の要望',
  press: '取材・メディア関連',
  other: 'その他',
};

export const CONTACT_INQUIRY_STATUSES = ['open', 'in_progress', 'resolved'] as const;
export type ContactInquiryStatus = (typeof CONTACT_INQUIRY_STATUSES)[number];

export const CONTACT_INQUIRY_STATUS_LABELS: Record<ContactInquiryStatus, string> = {
  open: '未対応',
  in_progress: '対応中',
  resolved: '対応完了',
};

export interface ContactInquiry {
  id?: string;
  userId: string;
  userEmail: string;
  userDisplayName: string;
  category: ContactInquiryCategory;
  message: string;
  status: ContactInquiryStatus;
  adminNote?: string;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  resolvedAt?: Timestamp | null;
  lastUpdatedBy?: string;
}
